import { useLang } from "../lib/useLang";
import { formatKWD } from "../lib/format";

/** Renders a KWD amount with 3 decimals and the localized currency label. */
export function Money({ value, className }: { value: number; className?: string }) {
  const { lang } = useLang();
  return <span className={className}>{formatKWD(value, lang)}</span>;
}
